import React, {Component, createRef} from "react";
import FJDropDown from "fj-components/FJDropDown";
import FJViewConstant from "../../../../../constant/FJViewConstant";
import FJLocalStore from "../../../../../store/FJLocalStore";
import styles from './FJSearchSort.module.less';
import classNames from 'classnames';
import InlineSVG from "react-inlinesvg";
import FJArrowUpDownIcon from '../../../../../icon/FJArrowUpDownIcon.svg';
import FJButton from "fj-components/FJButton";
import CheckIcon from '../../../../../icon/check.svg';

class FJSearchSort extends Component {

	constructor(props) {
		super(props);

		this._list = [
			{
				type: FJViewConstant.SORT_TYPE_RELEVANT,
				value: FJLocalStore._('most-relevant'),
			},
			{
				type: FJViewConstant.SORT_TYPE_DOWNLOADED,
				value: FJLocalStore._('most-downloaded'),
			},
			{
				type: FJViewConstant.SORT_TYPE_RATED,
				value: FJLocalStore._('highest-rated'),
			},
			{
				type: FJViewConstant.SORT_TYPE_RESENT,
				value: FJLocalStore._('most-recent'),
			},
			{
				type: FJViewConstant.SORT_TYPE_TRENDING,
				value: FJLocalStore._('trending-now'),
			}
		];

		this.dropDownRef = createRef();
	}

	_getCurrentValue = () => {
		let {
			sortType = FJViewConstant.SORT_TYPE_RELEVANT,
		} = this.props;

		return this._list.find(item => item.type === sortType).value;
	}

	_getList = () => {
		let {
			sortType = FJViewConstant.SORT_TYPE_RELEVANT,
		} = this.props;
		let lists = [];
		this._list.map((item, index) =>
			lists.push(
				<FJButton key={index}
									text={item.value}
									className={classNames(styles.c_item_box, {[styles.active]: item.type === sortType})}
									textClass={styles.c_item_text}
									icon={CheckIcon}
									iconClass={styles.c_item_icon}
									onClick={() => {
										this.props.sortChange(item.type);
									}}
				/>
			)
		)

		return lists;
	}

	hideDropDown = () => {
		this.dropDownRef.current.hide()
	}

	render() {

		let {
			visible,
		} = this.props;

		return (
			<FJDropDown overlay={
				<div className={styles.c_sort_panel}>
					{this._getList()}
				</div>
			}
									placement='bottomLeft'
									overlayClassName={styles.c_sort_box}
									isTopLayer
									triggerDisplay='flex'
									ref={this.dropDownRef}
									hasArrow={false}>
				<div className={classNames(styles.trigger_container, {[styles.show]: visible})}>
					<div className={styles.currentValue}>{this._getCurrentValue()}</div>
					<InlineSVG element='div' src={FJArrowUpDownIcon} className={styles.c_icon_box}/>
				</div>
			</FJDropDown>
		)
	}

}

export default FJSearchSort;